import { AnalyticsInterface } from '../../types/Analytics';
import { EVENT_KEYS } from 'constants-events';

type WorkOrderEvent = {
  userId: string;
  channelId: string;
  integrationId?: string;
  analytics: AnalyticsInterface;
};

type WorkOrderCreatedEvent = WorkOrderEvent;
type WorkOrderCommentCreatedEvent = WorkOrderEvent;

export function emitWorkOrderCreated({
  userId,
  channelId,
  integrationId,
  analytics,
}: WorkOrderCreatedEvent) {
  // FIXME: Event sent as analytic
  // @ts-ignore
  analytics.track(EVENT_KEYS.EVENT_WORK_ORDER_CREATED, {
    userId,
    channelId,
    integrationId,
  });
}

export function emitWorkOrderCommentCreated({
  userId,
  channelId,
  integrationId,
  analytics,
}: WorkOrderCommentCreatedEvent) {
  // FIXME: Event sent as analytic
  // @ts-ignore
  analytics.track(EVENT_KEYS.EVENT_WORK_ORDER_COMMENT_ADDED, {
    userId,
    channelId,
    integrationId,
  });
}
